var map = {
	"./E-V.mp4": 134,
	"./P-V.mp4": 128,
	"./V1.mp4": 512,
	"./V2.mp4": 513,
	"./V3.mp4": 514,
	"./V4.mp4": 515,
	"./V5.mp4": 516,
	"./V6.mp4": 517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;